import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  bread_crum_title:'',
  bread_crum_page_title:'',

 
};

const Header_Slice = createSlice({
  name: "Header",
  initialState,
  reducers: {
     set_bread_crum(state,action){
        const { title , pageTitle } = action.payload
         state.bread_crum_title =title
         state.bread_crum_page_title = pageTitle
     },
   
  

  },
});

export const {
    set_bread_crum
} = Header_Slice.actions

export default Header_Slice.reducer;